/*
 * @Descripttion: 页脚二级菜单
 * @version: V1.0
 * @Author: yuanxing(01407381)
 * @Date: 2022-01-19 10:43:05
 */
import allUrls from '@/utils/config'

export default   [ {
    path: '',
    cname: '产品与服务', 
    il8nName: 'navs.products_services', 
    children: [
      {
        cname: '国际服务',
        il8nName: 'navs.international_services', 
        path: '/product',
        params: { hash: 'product' },
      },
      {
        cname: '增值服务',
        path: '/product',
        name: 'increment',
        il8nName: 'modules.logisticsService.increment',
        params: { hash: 'increment' },
      },
    ],
  },
  {
    path: '',
    cname: '服务支持',
    il8nName: 'navs.serviceSupport',
    children: [
      {
        cname: '我要寄件',
        il8nName: 'serviceSupport.consigns.send',
        path: '/consign',
      },
      {
        cname: '运单追踪',
        il8nName: 'serviceSupport.querySupport.waybill',
        path: '/support/querySupport/waybill',
      },
      {
        cname: '运费时效查询',
        path: '/support/querySupport/freight_aging',
        name: 'increment',
        il8nName: 'modules.home.rates',
      },
      {
        name: 'DeclarationNotice',
        cname: '清关服务',
        path: '/support/customsClearance/declarationNotice',
        il8nName: 'navs.declarationNotice',
      },
      {
        name: 'dept',
        cname: '查服务网点',
        path: '/support/querySupport/dept',
        il8nName: 'serviceSupport.querySupport.service_dept',
      },
      {
        name: 'exce_rate',
        cname: '查汇率',
        path: '/support/querySupport/exce_rate',
        il8nName: 'serviceSupport.querySupport.exce_rate',
      },
      {
        name: 'reference_ID_Query',
        cname: '参考编号查询',
        path: '/support/querySupport/reference_ID_Query',
        il8nName: 'serviceSupport.invoice.reference_ID_Query',
      },
      // {
      //   name: 'prohibited_and_restricted_items',
      //   cname: '违法违规禁寄物品',
      //   path: '/support/querySupport/prohibited_and_restricted_items',
      //   hidden: { mb: false },
      //   il8nName: 'serviceSupport.invoice.prohibited_and_restricted_items',
      // },
      {
        name: 'holiday',
        cname: '查节假日服务计划',
        path: '/support/querySupport/holiday',
        il8nName: 'serviceSupport.querySupport.holidays.navTitle',
      },
      {
        path: '/support/faq',
        cname: '常见问题',
        name: 'commst_problem',
        il8nName: 'navs.FAQ',
      },
      {
        path: '/support/termsOfUse',
        cname: '使用条款',
        name: 'navs.termsOfUse',
        il8nName: 'navs.termsOfUse',
      },
      {
        path: '/support/privacyPolicy',
        cname: '隐私政策',
        name: 'serviceSupport.privacyPolicy',
        il8nName: 'navs.privacyPolicy',
      },
    ],
  },
  {
    path: '',
    cname: '关于我们',
    il8nName: 'modules.intro.title',
    children: [
      {
        path: '/about/intro/detail/about',
        cname: '关于顺丰',
        name: 'intro-detail-about',
        il8nName: 'modules.intro.about.sf',
      },
      {
        path: '/about/news',
        cname: '新闻资讯',
        name: 'news',
        il8nName: 'navs.news_updates', 
      }, 
      {
        path: '/about/board',
        cname: '服务公告',
        name: 'board',
        il8nName: 'modules.about.news_infos.notice',
      },
      {
        path: '/about/promotion',
        cname: '推广活动',
        name: 'promotion',
        il8nName: 'navs.promotions',
      }, 
      {
        path: '/about/careers',
        cname: '人才招聘',
        name: 'careers',
        il8nName: 'modules.about.careers',
      },
      {
        path: '/about/contact',
        cname: '客户服务热线',
        name: 'contact_us',
        il8nName: 'modules.about.relations',
      },
      {

        cname: '合作咨询',
        name: 'contact_us',
        il8nName: 'navs.cooperation_inquiry',
        path: allUrls.iuopCustomerUrl, 
      },
    ],
  }
]
